import ReactController from '~/controllers/react_controller'
import AwsOpensearchCpuRightSizeRecommendationsCharts from '~/dashboard/aws_opensearch_cpu_right_size_recommendations_charts'

export default class AwsOpensearchCpuRightSizeRecommendationsController extends ReactController {
  static values = {
    organizationId: String,
    optimizationId: String,
    resourceId: String,
  }

  createComponent() {
    return (
      <AwsOpensearchCpuRightSizeRecommendationsCharts
        organizationId={this.organizationIdValue}
        optimizationId={this.optimizationIdValue}
        resourceId={this.resourceIdValue}
      />
    )
  }
}
